import { Component, Event, EventEmitter, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'simple-accordion',
  styleUrl: 'simple-accordion.scss',
  shadow: true,
})
export class SimpleAccordion {
  @Prop() label = "";
  @Prop() isOpen = false;
  @Event() accordionToggle: EventEmitter;

  handleClick() {
    this.isOpen = !this.isOpen;
    this.accordionToggle.emit({ isOpen: this.isOpen });
  }

  render() {
    return (
      <Host>
        <div class="header" onClick={() => this.handleClick()}>
          <h6>{this.label}</h6>
          {this.isOpen ? <i class="material-icons-outlined arrow">keyboard_arrow_up</i> : <i class="material-icons-outlined arrow">keyboard_arrow_down</i>}
        </div>
        {this.isOpen && <div class="content"><slot></slot></div>}
      </Host>
    );
  }
}
